<template>
  <div class="next">
    <h1>{{ "标题：" + form.levelTitle }}</h1>
    <div class="btns">
      <el-button
        size="large"
        @click="$router.back(-1)"
        style="background: #f5f7fa; color: #000"
      >
        <el-icon><ArrowLeftBold /></el-icon> &nbsp;&nbsp;{{
          $t("Detail.back")
        }}</el-button
      >
      <el-button
        size="large"
        @click="submitForm('ruleForm')"
        style="background: #4f4f4f; color: #fff"
      >
        <el-icon><DocumentChecked /></el-icon> &nbsp;&nbsp;{{
          $t("Detail.save")
        }}</el-button
      >
    </div>
  </div>
  <el-segmented
    v-model="value"
    :options="options"
    block
    size="large"
    class="selectBar"
  />
  <div class="zhanwei2"></div>
  <div class="answer">
    <form1 v-show="value == '故事脚本'" ref="form1" :dataForm="form"></form1>
    <form2 v-show="value == '关卡设计'" ref="form2" :dataForm="form"></form2>
    <form3 v-show="value == '提示'" ref="form3" :dataForm="form"></form3>
    <form4 v-show="value == '景点知识'" ref="form4" :dataForm="form"></form4>
    <form5
      v-show="value == '地点导航'"
      ref="form5"
      :dataForm="form"
      :dataForm2="form2"
    ></form5>
    <!--    <form6 v-show="value == '游戏复盘'" ref="form6" :dataForm="form"></form6>-->
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, ref } from "vue";
import { ArrowLeftBold, DocumentChecked, Plus } from "@element-plus/icons-vue";
import type { FormRules, UploadProps, UploadUserFile } from "element-plus";
import { detailForm } from "@/views/view";
import form1 from "@/components/detail/component/form1.vue";
import form2 from "@/components/detail/component/form2.vue";
import form3 from "@/components/detail/component/form3.vue";
import form4 from "@/components/detail/component/form4.vue";
import form5 from "@/components/detail/component/form5.vue";
import form6 from "@/components/detail/component/form6.vue";
import { ElMessage } from "element-plus";
const validateNotEmpty = (rule: any, value: string, callback: any) => {
  if (value.trim() === "") {
    callback(new Error(rule.message));
  } else {
    callback();
  }
};

export default defineComponent({
  name: "App",
  data() {
    const form: any = {
      id: "",
      levelTitle: "",
      levelContent: "",
      difficulty: 1,
      storyTitle: "",
      storyContent: "",
      clues: "",
      answers: "",
      tipTitle: "",
      tipContent: "",
      belongId: "",
      createTime: "",
      updateTime: null,
      gameLevelId: "",
    };
    return {
      form,
      form2: {
        mapSelect: "",
        customizeMap: "",
      },
      fileList: ref<UploadUserFile[]>([]),
      dialogImageUrl: "",
      dialogVisible: false,
      rules: reactive<FormRules>({
        levelTitle: [
          {
            required: true,
            message: "关卡标题不能为空",
            trigger: "blur",
            validator: validateNotEmpty,
          },
        ],
        levelContent: [
          {
            required: true,
            message: "P关卡谜题内容不能为空",
            trigger: "blur",
            validator: validateNotEmpty,
          },
        ],
        storyTitle: [
          {
            required: true,
            message: "故事标题不能为空",
            trigger: "blur",
            validator: validateNotEmpty,
          },
        ],
        storyContent: [
          {
            required: true,
            message: "故事内容不能为空",
            trigger: "blur",
            validator: validateNotEmpty,
          },
        ],
        answers: [
          {
            required: true,
            message: "谜题答案不能为空",
            trigger: "blur",
            validator: validateNotEmpty,
          },
        ],
      }),
      options: [
        "地点导航",
        "故事脚本",
        "关卡设计",
        "提示",
        "景点知识",
        // "游戏复盘",
      ],
      value: "地点导航",
    };
  },
  components: {
    DocumentChecked,
    Plus,
    ArrowLeftBold,
    form1,
    form2,
    form3,
    form4,
    form5,
    form6,
  },
  computed: {
    UpdateApi() {
      return process.env.VUE_APP_Update_API;
    },
  },
  watch: {},
  mounted() {
    const { id, detailId } = this.$route.params;
    this.id = detailId;
    const { games } = this.$store.state.game;

    if (id !== 0) {
      const game = games.find((item: any) => item.id === id);

      if (game && game.gameLevelId) {
        this.gameLevelId = game.gameLevelId;
      }

      if (game.mapSelect === "自定义地图" && game.customizeMap) {
        this.form2.customizeMap = game.customizeMap;
        this.form2.mapSelect = game.mapSelect;
      }
    }
    this.$store
      .dispatch("game/getLevelDetail", { levelId: this.$route.params.detailId })
      .then((res: any) => {
        this.form = res.levelInfo;
        if (res.levelInfo.arrows) {
          localStorage.setItem("generatedImages", res.levelInfo.arrows);
        } else {
          localStorage.setItem("generatedImages", "");
        }
      })
      .catch(() => {});
  },
  methods: {
    submitForm(formName) {
      const a = this.$refs["form1"].$data.form;
      const b = this.$refs["form2"].$data.form;
      // const c = this.$refs["form3"].$data.form;
      const d = this.$refs["form4"].$data.form;
      const e = this.$refs["form5"].$data.form;
      // const f = this.$refs["form6"].$data.form;

      let arrows =
        localStorage.getItem("generatedImages") != "null"
          ? localStorage.getItem("generatedImages")
          : "";

      let form = {
        ...a,
        ...b,
        ...d,
        ...e,
        // ...f,
        id: this.id,
        arrows: arrows,
      };

      if (!a.storyCover || !a.storyDesc || !a.storyTitle) {
        this.value = "故事脚本";
        ElMessage.warning({
          message: "故事脚本未完成",
        });
        return;
      } else if (!b.levelTitle || !b.region) {
        this.value = "关卡设计";
        ElMessage.warning({
          message: "关卡设计未完成",
        });
        return;
      } else if (!e.address || e.lat == 0 || e.lng == 0) {
        this.value = "地点导航";
        ElMessage.warning({
          message: "地点导航未完成",
        });
        return;
      }
      this.$store
        .dispatch("game/saveLevel", {
          levelBean: form,
        })
        .then((res: any) => {
          this.$refs["form3"].saveTip();
          this.$store.dispatch("game/getGameLevelList", {
            gameLevelId: this.gameLevelId,
          });
        });
    },
    handlePictureCardPreview(uploadFile: any): UploadProps["onPreview"] | void {
      this.dialogImageUrl = uploadFile.url!;
      this.dialogVisible = true;
    },
    handleRemove(
      uploadFile: any,
      uploadFiles: any
    ): UploadProps["onRemove"] | void {
      console.log(uploadFile, uploadFiles);
    },
  },
});
</script>

<style lang="less" scoped>
// 统一设计变量
@primary-color: #5d5fef;
@primary-light: #f0f2ff;
@text-main: #1e293b;
@text-sub: #64748b;
@text-muted: #94a3b8;
@border-color: #e2e8f0;
@card-border: #f1f5f9;

.zhanwei2 {
  height: 20px;
}

// 顶部操作栏
.next {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 16px auto 20px;
  padding: 0 16px;
  box-sizing: border-box;

  h1 {
    font-size: 20px;
    font-weight: 700;
    color: @text-main;
    margin: 0;
    letter-spacing: 0.5px;
    display: flex;
    align-items: center;
    gap: 8px;

    &::before {
      content: "";
      width: 4px;
      height: 18px;
      background: @primary-color;
      border-radius: 2px;
      display: inline-block;
    }
  }

  .btns {
    display: flex;
    align-items: center;
    gap: 12px;

    .el-button {
      height: 40px;
      padding: 0 20px;
      border-radius: 8px;
      font-weight: 500;
      font-size: 14px;
      transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);

      // 返回按钮美化
      &:first-child {
        background: #ffffff !important;
        border: 1px solid @border-color !important;
        color: @text-sub !important;

        &:hover {
          background: #f8fafc !important;
          color: @text-main !important;
          border-color: #cbd5e1 !important;
          transform: translateY(-1px);
        }
      }

      // 保存按钮美化
      &:last-child {
        background: @primary-color !important;
        border-color: @primary-color !important;
        color: #ffffff !important;
        font-weight: 600;
        box-shadow: 0 4px 12px rgba(93, 95, 239, 0.25);

        &:hover {
          background: #4b4de0 !important;
          border-color: #4b4de0 !important;
          transform: translateY(-1px);
          box-shadow: 0 6px 16px rgba(93, 95, 239, 0.35);
        }

        &:active {
          transform: translateY(0);
        }
      }

      .el-icon {
        font-size: 15px;
      }
    }
  }
}

// 分段选择控制器美化
.selectBar {
  max-width: 1200px;
  margin: 0 auto;
  padding: 4px;
  background-color: #f1f5f9;
  border-radius: 10px;
  border: 1px solid @border-color;
  box-sizing: border-box;

  :deep(.el-segmented__item) {
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    color: @text-sub;
    padding: 8px 0;
    transition: all 0.25s ease;

    &:hover {
      color: @primary-color;
    }

    &.is-selected {
      background-color: #ffffff;
      color: #ffffff;
      box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
    }
  }
}

// 核心内容区卡片化
.answer {
  max-width: 1200px;
  margin: 0 auto 40px;
  padding: 28px 32px;
  background-color: #ffffff;
  border: 1px solid @card-border;
  border-radius: 16px;
  box-shadow: 0 4px 20px -2px rgba(15, 23, 42, 0.04),
    0 2px 6px -1px rgba(15, 23, 42, 0.02);
  box-sizing: border-box;
}

@media screen and (max-width: 768px) {
  .next {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;

    .btns {
      width: 100%;
      justify-content: flex-end;
    }
  }

  .answer {
    padding: 20px 16px;
  }
}
</style>
